import { render } from "./SliderBackground.vue?vue&type=template&id=1687d838&scoped=true"
import script from "./SliderBackground.vue?vue&type=script&lang=js"
export * from "./SliderBackground.vue?vue&type=script&lang=js"

import "@/Common/Styles/sliderBackground.scss?vue&type=style&index=0&id=1687d838&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1687d838"]])

export default __exports__